import { AbstractPmsApiService } from "./abstract.service";
import {PaymentGatewayApiSetting} from "../models/payment-gateway-api-setting.model";

/**
 * @abstract
 * @extends {AbstractPmsApiService<PaymentGatewayApiSetting>}
 */
export class PaymentGatewayApiSettingService extends AbstractPmsApiService {

    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {

        return '/property/:propertyId/payment-gateway-api-setting';
    }

    /**
     * @param {Object.<string, *>} attributes
     * @returns {PaymentGatewayApiSetting}
     * @protected
     */
    newModel(attributes, ...params) {

        return new PaymentGatewayApiSetting(attributes);
    }

    /**
     * @param {Property=} property
     * @returns {Promise.<PaymentGatewayApiSetting>}
     */
    get(property) {

        const url = this.url({propertyId: property.id});

        return this.http
            .get(url, {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {Property} property
     * @param {PaymentGatewayApiSetting} settings
     * @returns {Promise.<PaymentGatewayApiSetting>}
     */
    save(property, settings) {

        const url = this.url({propertyId: property.id});

        return this.http
            .post(url, settings, {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }

    create(model) {
        return Promise.resolve(undefined);
    }

    delete(model) {
        return Promise.resolve(false);
    }

    update(model) {
        return Promise.resolve(undefined);
    }
}



// WEBPACK FOOTER //
// ./src/pms-api/services/payment-gateway-api-setting.service.js